import { DataTableStatisticCSVItem, StatisticDtoScore } from "components/StatisticsDataTable/Dto/DataTableStatisticDto";
import { MUIDataTableColumn } from "mui-datatables";
import type { TFunction } from "i18next";

type RowShape = { data: unknown[] | DataTableStatisticCSVItem };

const esc = (v: unknown, sep: string) => {
    const s = v == null ? "" : String(v);
    return /["\n\r]/.test(s) || s.includes(sep)
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };

const toRowArray = (
    row: { data: unknown[] | DataTableStatisticCSVItem },
  ): unknown[] => {
    if (Array.isArray(row.data)) {
        return row.data;
    }
    const o = row.data as DataTableStatisticCSVItem;
    return [
      o.userDisplayName,
      o.lessonName,
      o.userTagA,
      o.userTagB,
      o.dateCompleted,
      o.rewardType,
      o.timeSpent,
      o.score,
    ];
  };

export const generateFileName = (): string => {
    return `statistic_table_report_${new Date()
        .toISOString()
        .replace(/[-:]/g, '')   // remove - and :
        .replace(/\..+/, '')    // drop milliseconds and Z
        .replace('T', '_')      // swap T for _
        .slice(0, 13)}.csv`
}

export const buildStatisticsCsv = (
  t: TFunction,
  columns: MUIDataTableColumn[],
  data: Array<RowShape>,
  opts?: { separator?: string; idxCompleted?: number; idxPoints?: number }
): string => {
  const SEP = opts?.separator ?? ";";
  const idxCompleted = opts?.idxCompleted ?? 4;
  const idxPoints = opts?.idxPoints ?? 7;

  // Header: replace "Punkty" with two columns
  const headerCells: string[] = [];
  columns.forEach((col, i) => {
    if (i === idxPoints) {
      headerCells.push(t('statistics.earnedPoints'), t('statistics.maxPoints'));
    } else {
      headerCells.push(String(col?.label ?? col?.name ?? ""));
    }
  });
  const header = headerCells.map((h) => esc(h, SEP)).join(SEP);

  const rows = data
    .map((row) => {
      const arr = toRowArray(row);
      const cells: string[] = [];

      const pointsObj = (arr[idxPoints] ?? {}) as Partial<StatisticDtoScore>;

      columns.forEach((_, i) => {
        if (i === idxCompleted) {
          const v = arr[i] as string | null | undefined;
          const out =
            v == null || v === ""
              ? t("statistics.lessonProgressStatus.canceled")
              : String(v);
          cells.push(esc(out, SEP));
        } else if (i === idxPoints) {
          const scored = pointsObj.scoredPoints ?? "";
          const max = pointsObj.maxPoints ?? "";
          cells.push(esc(scored, SEP), esc(max, SEP));
        } else {
          cells.push(esc(arr[i], SEP));
        }
      });

      return cells.join(SEP);
    })
    .join("\n");

  return `\uFEFF${header}\n${rows}`;
}